module.exports = __webpack_public_path__ + "06_bob_brown.ae4c0c3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer5/06_bob_brown.png
// module id = VqmF
// module chunks = 0